import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { AlertCircle, ExternalLink, Activity, Wifi, ShieldCheck } from 'lucide-react';

const MonitorServicios = () => {
  const { user } = useAuth();
  
  // Try to find the monitor URL from various possible locations in the user object
  // It might be directly on the user, inside a cliente object, or cliente_data
  const monitorUrlRaw = user?.monitor_url || user?.cliente?.monitor_url || user?.cliente_data?.monitor_url;
  
  // Función helper para limpiar y formatear la URL
  const getFormattedUrl = (url) => {
    if (!url) return null;
    let cleanUrl = url.trim();
    // Si no tiene protocolo, asumir HTTPS
    if (!cleanUrl.startsWith('http://') && !cleanUrl.startsWith('https://')) {
      return `https://${cleanUrl}`;
    }
    // Si la aplicación se sirve por HTTPS, forzar iframe a ser HTTPS
    if (window.location.protocol === 'https:' && cleanUrl.startsWith('http://')) {
        return cleanUrl.replace('http://', 'https://');
    }
    return cleanUrl;
  };

  const monitorUrl = getFormattedUrl(monitorUrlRaw);

  if (!monitorUrl) {
    return (
      <div className="flex flex-col items-center justify-center p-8 text-center min-h-[60vh] animate-in fade-in duration-700">
        <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 max-w-md relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-50 rounded-bl-full -mr-16 -mt-16 opacity-50"></div>
          
          <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-6 relative z-10">
            <Activity className="h-8 w-8 text-emerald-500" />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Servicio No Configurado</h2>
          <p className="text-gray-500 mb-8 leading-relaxed">
            Actualmente no tienes asignada una página de estado para el monitoreo de tus servicios.
            <br/><br/>
            Contacta al soporte técnico para habilitar tu panel de control personalizado.
          </p>
          
          <div className="flex items-center justify-center gap-2 text-xs text-gray-400 font-medium uppercase tracking-wider">
            <ShieldCheck className="w-4 h-4" />
            Elements Tech Monitoring
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full w-full bg-slate-50 relative overflow-hidden monitor-container" style={{ minHeight: 'calc(100vh - 64px)' }}>
      {/* Header flotante */}
      <div className="absolute top-4 left-4 right-4 z-20 flex justify-between items-center bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-lg border border-white/20 transition-all hover:bg-white">
        <div className="flex items-center gap-3">
          <div className="bg-green-100 p-2 rounded-lg">
             <Wifi className="w-5 h-5 text-green-600 animate-pulse" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900 leading-tight">Estado de Servicios</h1>
            <div className="flex items-center gap-2">
               <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
               <p className="text-xs font-medium text-green-600">Monitoreo en Tiempo Real</p>
            </div>
          </div>
        </div>
        
        <a 
          href={monitorUrl} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="group flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-emerald-50 text-slate-600 hover:text-emerald-600 rounded-lg text-sm font-semibold transition-all duration-200 border border-transparent hover:border-emerald-100"
        >
          <span>Abrir Externamente</span>
          <ExternalLink className="h-4 w-4 transition-transform group-hover:scale-110" />
        </a>
      </div>
      
      {/* Iframe Contenedor */}
      <div className="flex-1 w-full h-full relative z-10 pt-24 px-4 pb-4">
        <div className="w-full h-full rounded-2xl overflow-hidden shadow-2xl border border-gray-200 bg-white">
          <iframe 
            src={monitorUrl}
            title="Panel de Monitoreo Elements"
            className="w-full h-full border-0 bg-white"
            allow="autoplay; fullscreen"
            loading="lazy"
          />
        </div>
      </div>
      
      {/* Fondo decorativo */}
      <div className="absolute inset-0 z-0 opacity-30 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-emerald-200 rounded-full blur-[100px]" />
          <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-green-200 rounded-full blur-[100px]" />
      </div>
    </div>
  );
};

export default MonitorServicios;
